import React, { useState, useEffect, useCallback } from "react";
import contactService from "../../services/contactService";

// Icons matching Group.jsx design
const MagnifyingGlassIcon = ({ className }) => (
  <svg className={className} fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor">
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="m21 21-5.197-5.197m0 0A7.5 7.5 0 1 0 5.196 5.196a7.5 7.5 0 0 0 10.607 10.607Z"
    />
  </svg>
);

const PlusIcon = ({ className }) => (
  <svg className={className} fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor">
    <path strokeLinecap="round" strokeLinejoin="round" d="M12 4.5v15m7.5-7.5h-15" />
  </svg>
);

const PencilIcon = ({ className }) => (
  <svg className={className} fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor">
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="m16.862 4.487 1.687-1.688a1.875 1.875 0 1 1 2.652 2.652L10.582 16.07a4.5 4.5 0 0 1-1.897 1.13L6 18l.8-2.685a4.5 4.5 0 0 1 1.13-1.897l8.932-8.931Zm0 0L19.5 7.125M18 14v4.75A2.25 2.25 0 0 1 15.75 21H5.25A2.25 2.25 0 0 1 3 18.75V8.25A2.25 2.25 0 0 1 5.25 6H10"
    />
  </svg>
);

const TrashIcon = ({ className }) => (
  <svg className={className} fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor">
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="m14.74 9-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 0 1-2.244 2.077H8.084a2.25 2.25 0 0 1-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 0 0-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 0 1 3.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 0 0-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 0 0-7.5 0"
    />
  </svg>
);

const XMarkIcon = ({ className }) => (
  <svg className={className} fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor">
    <path strokeLinecap="round" strokeLinejoin="round" d="M6 18 18 6M6 6l12 12" />
  </svg>
);

const ChevronLeftIcon = ({ className }) => (
  <svg className={className} fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor">
    <path strokeLinecap="round" strokeLinejoin="round" d="M15.75 19.5 8.25 12l7.5-7.5" />
  </svg>
);

const ChevronRightIcon = ({ className }) => (
  <svg className={className} fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor">
    <path strokeLinecap="round" strokeLinejoin="round" d="m8.25 4.5 7.5 7.5-7.5 7.5" />
  </svg>
);

const CheckIcon = ({ className }) => (
  <svg className={className} fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor">
    <path strokeLinecap="round" strokeLinejoin="round" d="m4.5 12.75 6 6 9-13.5" />
  </svg>
);

const UsersIcon = ({ className }) => (
  <svg className={className} fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor">
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M15 19.128a9.38 9.38 0 0 0 2.625.372 9.337 9.337 0 0 0 4.121-.952 4.125 4.125 0 0 0-7.533-2.493M15 19.128v-.003c0-1.113-.285-2.16-.786-3.07M15 19.128v.106A12.318 12.318 0 0 1 8.624 21c-2.331 0-4.512-.645-6.374-1.766l-.001-.109a6.375 6.375 0 0 1 11.964-3.07M12 6.375a3.375 3.375 0 1 1-6.75 0 3.375 3.375 0 0 1 6.75 0Zm8.25 2.25a2.625 2.625 0 1 1-5.25 0 2.625 2.625 0 0 1 5.25 0Z"
    />
  </svg>
);

const EyeIcon = ({ className }) => (
  <svg className={className} fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor">
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M2.036 12.322a1.012 1.012 0 0 1 0-.639C3.423 7.51 7.36 4.5 12 4.5c4.638 0 8.573 3.007 9.963 7.178.07.207.07.431 0 .639C20.577 16.49 16.64 19.5 12 19.5c-4.638 0-8.573-3.007-9.963-7.178Z"
    />
    <path strokeLinecap="round" strokeLinejoin="round" d="M15 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z" />
  </svg>
);

export default function GroupTab() {
  const [groups, setGroups] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [groupsPerPage, setGroupsPerPage] = useState(10);

  // Modals
  const [showCreateModal, setShowCreateModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [showViewModal, setShowViewModal] = useState(false);
  const [selectedGroup, setSelectedGroup] = useState(null);
  const [groupContacts, setGroupContacts] = useState([]);
  const [loadingContacts, setLoadingContacts] = useState(false);

  // Form
  const [formData, setFormData] = useState({
    groupName: "",
    otherMessage: "",
  });
  const [isSubmitting, setIsSubmitting] = useState(false);

  const loadGroups = useCallback(async () => {
    setLoading(true);
    try {
      const res = await contactService.groups.get({ limit: 500 });
      if (res && res.success) {
        setGroups(Array.isArray(res.data) ? res.data : []);
      } else if (Array.isArray(res)) {
        setGroups(res);
      }
    } catch (error) {
      console.error("Error loading groups:", error);
      setGroups([]);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    loadGroups();
  }, [loadGroups]);

  const resetForm = () => {
    setFormData({
      groupName: "",
      otherMessage: "",
    });
    setSelectedGroup(null);
  };

  const handleCreateGroup = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    try {
      const payload = {
        groupName: formData.groupName,
        str_group_name: formData.groupName,
        otherMessage: formData.otherMessage,
        str_description: formData.otherMessage,
        description: formData.otherMessage,
      };

      const res = await contactService.groups.create(payload);
      if (res && (res.success || res._id)) {
        await loadGroups();
        setShowCreateModal(false);
        resetForm();
      } else {
        alert(res?.error || res?.message || "Failed to create group");
      }
    } catch (err) {
      alert(err.message || "Failed to create group");
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleEditGroup = (group) => {
    setSelectedGroup(group);
    setFormData({
      groupName: group.groupName || group.str_group_name || "",
      otherMessage: group.otherMessage || group.str_description || group.description || "",
    });
    setShowEditModal(true);
  };

  const handleUpdateGroup = async (e) => {
    e.preventDefault();
    if (!selectedGroup) return;
    setIsSubmitting(true);
    try {
      const payload = {
        groupName: formData.groupName,
        str_group_name: formData.groupName,
        otherMessage: formData.otherMessage,
        str_description: formData.otherMessage,
        description: formData.otherMessage,
      };

      const id = selectedGroup._id || selectedGroup.id;
      const res = await contactService.groups.edit(id, payload);
      if (res && (res.success || res._id)) {
        await loadGroups();
        setShowEditModal(false);
        resetForm();
      } else {
        alert(res?.error || res?.message || "Failed to update group");
      }
    } catch (err) {
      alert(err.message || "Failed to update group");
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleDeleteGroup = async (groupId) => {
    if (
      !window.confirm(
        "Are you sure you want to delete this group? This will also delete all contacts associated with this group."
      )
    ) {
      return;
    }

    try {
      const res = await contactService.groups.delete(groupId);
      if (res && res.success !== false) {
        setGroups((prev) => prev.filter((g) => (g._id || g.id) !== groupId));
      } else {
        alert(res?.error || "Failed to delete group");
      }
    } catch (err) {
      alert(err.message || "Failed to delete group");
    }
  };

  const handleViewGroup = async (group) => {
    setSelectedGroup(group);
    setShowViewModal(true);
    setLoadingContacts(true);
    setGroupContacts([]);

    try {
      const id = group._id || group.id;
      const res = await contactService.getContactsByGroup(id);
      if (res && res.success) {
        setGroupContacts(res.data || []);
      } else {
        // Fallback: search contacts by group id
        const contactsRes = await contactService.get({ limit: 1000 });
        if (contactsRes && contactsRes.data) {
          const matched = contactsRes.data.filter((c) => {
            const gid = c.str_group_id || c.group?._id || (c.arr_groups && c.arr_groups[0]);
            return gid === id || c.str_group_name === group.str_group_name;
          });
          setGroupContacts(matched);
        }
      }
    } catch (error) {
      console.error("Error loading group contacts:", error);
      setGroupContacts([]);
    } finally {
      setLoadingContacts(false);
    }
  };

  // Filtering
  const getFilteredGroups = () => {
    let filtered = groups;

    if (searchTerm) {
      const q = searchTerm.toLowerCase();
      filtered = filtered.filter((group) => {
        const name = (group.groupName || group.str_group_name || "").toLowerCase();
        const desc = (group.otherMessage || group.str_description || group.description || "").toLowerCase();
        return name.includes(q) || desc.includes(q);
      });
    }

    return filtered;
  };

  // Stats calculation
  const getGroupStats = () => {
    const total = groups.length;
    const withMembers = groups.filter((g) => {
      const count = g.members?.length || g.int_total_contacts || 0;
      return count > 0;
    }).length;
    const withoutMembers = total - withMembers;
    return { total, withMembers, withoutMembers };
  };

  const filteredGroups = getFilteredGroups();
  const totalPages = Math.ceil(filteredGroups.length / groupsPerPage) || 1;
  const startIndex = (currentPage - 1) * groupsPerPage;
  const paginatedGroups = filteredGroups.slice(startIndex, startIndex + groupsPerPage);
  const stats = getGroupStats();

  if (loading && groups.length === 0) {
    return (
      <div className="py-20 flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-green-600 mx-auto mb-4"></div>
          <p className="text-gray-600 dark:text-gray-400">Loading groups...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="space-y-6">
      {/* Header section with Create Button */}
      <div className="bg-white dark:bg-gray-800 rounded-2xl shadow-sm border border-gray-200 dark:border-gray-700 p-6">
        <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-4">
          <div>
            <h1 className="text-3xl lg:text-4xl font-bold bg-gradient-to-r from-green-700 to-blue-600 bg-clip-text text-transparent mb-2">
              Groups
            </h1>
            <p className="text-gray-600 dark:text-gray-400 text-sm sm:text-base">
              Organize contacts into groups for targeted messaging
            </p>
          </div>
          <div className="flex items-center gap-3">
            <button
              onClick={() => {
                resetForm();
                setShowCreateModal(true);
              }}
              className="inline-flex items-center px-4 py-2.5 bg-gradient-to-r from-green-600 to-blue-600 font-semibold rounded-xl hover:from-purple-700 hover:to-pink-700 text-white transition-all duration-200 shadow-sm shadow-green-500/20 text-xs sm:text-sm cursor-pointer"
            >
              <PlusIcon className="w-5 h-5 mr-2" />
              Create Group
            </button>
          </div>
        </div>
      </div>

      {/* Stats Cards */}
      <div className="grid grid-cols-2 md:grid-cols-3 gap-4">
        <div className="bg-white dark:bg-gray-800 rounded-xl p-4 shadow-sm border border-gray-200 dark:border-gray-700">
          <div className="text-2xl font-bold text-gray-900 dark:text-white">{stats.total}</div>
          <div className="text-xs sm:text-sm text-gray-600 dark:text-gray-400 mt-0.5">Total Groups</div>
        </div>
        <div className="bg-white dark:bg-gray-800 rounded-xl p-4 shadow-sm border border-gray-200 dark:border-gray-700">
          <div className="text-2xl font-bold text-purple-600">{stats.withMembers}</div>
          <div className="text-xs sm:text-sm text-gray-600 dark:text-gray-400 mt-0.5">With Members</div>
        </div>
        <div className="bg-white dark:bg-gray-800 rounded-xl p-4 shadow-sm border border-gray-200 dark:border-gray-700 col-span-2 md:col-span-1">
          <div className="text-2xl font-bold text-pink-600">{stats.withoutMembers}</div>
          <div className="text-xs sm:text-sm text-gray-600 dark:text-gray-400 mt-0.5">Empty Groups</div>
        </div>
      </div>

      {/* Filters */}
      <div className="bg-white dark:bg-gray-800 rounded-xl shadow-sm border border-gray-200 dark:border-gray-700 p-4 sm:p-6">
        <div className="flex flex-col sm:flex-row flex-wrap gap-4 items-stretch sm:items-center">
          {/* Search */}
          <div className="relative flex-1 min-w-[240px]">
            <MagnifyingGlassIcon className="w-5 h-5 absolute left-4 top-1/2 transform -translate-y-1/2 text-gray-400" />
            <input
              type="text"
              placeholder="Search groups..."
              value={searchTerm}
              onChange={(e) => {
                setSearchTerm(e.target.value);
                setCurrentPage(1);
              }}
              className="pl-12 pr-4 py-2 w-full border border-gray-300 dark:border-gray-600 rounded-xl bg-white dark:bg-gray-700 text-gray-900 dark:text-white text-xs sm:text-sm focus:ring-2 focus:ring-purple-500 focus:border-transparent transition-all duration-200"
            />
          </div>

          {/* Per-page Selector */}
          <div className="relative">
            <select
              value={groupsPerPage}
              onChange={(e) => {
                setGroupsPerPage(Number(e.target.value));
                setCurrentPage(1);
              }}
              className="px-4 py-2 border border-gray-300 dark:border-gray-600 rounded-xl bg-white dark:bg-gray-700 text-gray-900 dark:text-white text-xs sm:text-sm focus:ring-2 focus:ring-purple-500 focus:border-transparent transition-all duration-200"
            >
              <option value={10}>10 per page</option>
              <option value={20}>20 per page</option>
              <option value={50}>50 per page</option>
              <option value={100}>100 per page</option>
            </select>
          </div>
        </div>
      </div>

      {/* Groups Table */}
      <div className="bg-white dark:bg-gray-800 rounded-2xl shadow-sm border border-gray-200 dark:border-gray-700 overflow-hidden">
        {paginatedGroups.length === 0 ? (
          <div className="py-12 px-4 text-center">
            <h3 className="text-xl font-semibold text-gray-900 dark:text-white mb-2">No Groups Found</h3>
            <p className="text-gray-600 dark:text-gray-400 mb-6 max-w-md mx-auto text-sm">
              {groups.length === 0
                ? "You don't have any groups yet. Create your first group to organize contacts."
                : "No groups match your current search criteria."}
            </p>
            {groups.length === 0 && (
              <button
                onClick={() => {
                  resetForm();
                  setShowCreateModal(true);
                }}
                className="inline-flex items-center px-6 py-3 bg-gradient-to-r from-purple-600 to-pink-600 text-white font-semibold rounded-xl hover:from-purple-700 hover:to-pink-700 transition-all duration-200 text-sm cursor-pointer"
              >
                <PlusIcon className="w-5 h-5 mr-2" />
                Create Group
              </button>
            )}
          </div>
        ) : (
          <>
            <div className="overflow-x-auto">
              <table className="min-w-full divide-y divide-gray-200 dark:divide-gray-700">
                <thead className="bg-gray-50 dark:bg-gray-700/60">
                  <tr>
                    <th className="px-6 py-3.5 text-left text-xs font-semibold text-gray-500 dark:text-gray-300 uppercase tracking-wider w-16">
                      #
                    </th>
                    <th className="px-6 py-3.5 text-left text-xs font-semibold text-gray-500 dark:text-gray-300 uppercase tracking-wider">
                      Group Name
                    </th>
                    <th className="px-6 py-3.5 text-left text-xs font-semibold text-gray-500 dark:text-gray-300 uppercase tracking-wider">
                      Description
                    </th>
                    <th className="px-6 py-3.5 text-left text-xs font-semibold text-gray-500 dark:text-gray-300 uppercase tracking-wider">
                      Members
                    </th>
                    <th className="px-6 py-3.5 text-left text-xs font-semibold text-gray-500 dark:text-gray-300 uppercase tracking-wider">
                      Created
                    </th>
                    <th className="px-6 py-3.5 text-right text-xs font-semibold text-gray-500 dark:text-gray-300 uppercase tracking-wider">
                      Actions
                    </th>
                  </tr>
                </thead>
                <tbody className="bg-white dark:bg-gray-800 divide-y divide-gray-200 dark:divide-gray-700">
                  {paginatedGroups.map((group, index) => {
                    const name = group.groupName || group.str_group_name || "Unnamed Group";
                    const description =
                      group.otherMessage || group.str_description || group.description || "No description";
                    const membersCount = group.members?.length || group.int_total_contacts || 0;
                    const createdDate = group.createdAt || group.dttm_created_on;
                    const formattedDate = createdDate ? new Date(createdDate).toLocaleDateString() : "-";
                    const createdBy = group.createdBy?.email || group.str_created_by || "Admin";
                    const id = group._id || group.id;

                    return (
                      <tr
                        key={id || index}
                        className="hover:bg-gray-50/80 dark:hover:bg-gray-700/50 transition-colors duration-150"
                      >
                        <td className="px-6 py-4 whitespace-nowrap text-xs font-medium text-gray-400">
                          #{(currentPage - 1) * groupsPerPage + index + 1}
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap">
                          <div className="flex items-center">
                            <div className="flex-shrink-0 h-10 w-10">
                              <div className="h-10 w-10 rounded-full bg-gradient-to-r from-purple-500 to-pink-500 flex items-center justify-center shadow-sm">
                                <UsersIcon className="w-5 h-5 text-white" />
                              </div>
                            </div>
                            <div className="ml-3.5">
                              <div className="text-sm font-semibold text-gray-900 dark:text-white">
                                {name}
                              </div>
                              <div className="text-xs text-gray-500 dark:text-gray-400">
                                Created by {createdBy}
                              </div>
                            </div>
                          </div>
                        </td>
                        <td className="px-6 py-4">
                          <div className="text-xs text-gray-600 dark:text-gray-400 max-w-xs">
                            <p className="line-clamp-2 break-words">{description}</p>
                          </div>
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap">
                          <span className="inline-flex items-center px-2.5 py-1 rounded-full text-xs font-semibold bg-purple-100 text-purple-800 dark:bg-purple-900/40 dark:text-purple-200">
                            {membersCount} members
                          </span>
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap text-xs text-gray-500 dark:text-gray-400">
                          {formattedDate}
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap text-right text-sm font-medium">
                          <div className="flex items-center justify-end space-x-2">
                            <button
                              onClick={() => handleViewGroup(group)}
                              className="p-2 text-green-600 dark:text-green-400 hover:bg-green-50 dark:hover:bg-green-900/20 rounded-lg transition-colors duration-200 cursor-pointer"
                              title="View Group"
                            >
                              <EyeIcon className="w-4 h-4" />
                            </button>
                            <button
                              onClick={() => handleEditGroup(group)}
                              className="p-2 text-blue-600 dark:text-blue-400 hover:bg-blue-50 dark:hover:bg-blue-900/20 rounded-lg transition-colors duration-200 cursor-pointer"
                              title="Edit Group"
                            >
                              <PencilIcon className="w-4 h-4" />
                            </button>
                            <button
                              onClick={() => handleDeleteGroup(id)}
                              className="p-2 text-red-600 dark:text-red-400 hover:bg-red-50 dark:hover:bg-red-900/20 rounded-lg transition-colors duration-200 cursor-pointer"
                              title="Delete Group"
                            >
                              <TrashIcon className="w-4 h-4" />
                            </button>
                          </div>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>

            {/* Pagination */}
            {totalPages > 1 && (
              <div className="px-6 py-4 border-t border-gray-200 dark:border-gray-700 flex flex-col sm:flex-row items-center justify-between gap-4">
                <div className="text-xs sm:text-sm text-gray-600 dark:text-gray-400">
                  Showing {(currentPage - 1) * groupsPerPage + 1} to{" "}
                  {Math.min(currentPage * groupsPerPage, filteredGroups.length)} of{" "}
                  {filteredGroups.length} groups
                </div>

                <div className="flex items-center space-x-1">
                  <button
                    onClick={() => setCurrentPage((p) => Math.max(1, p - 1))}
                    disabled={currentPage === 1}
                    className="p-2 rounded-lg border border-gray-200 dark:border-gray-700 text-gray-600 dark:text-gray-400 hover:text-gray-900 dark:hover:text-white disabled:opacity-40 disabled:cursor-not-allowed transition-colors"
                  >
                    <ChevronLeftIcon className="w-4 h-4" />
                  </button>

                  {Array.from({ length: Math.min(5, totalPages) }, (_, i) => {
                    const pageNum = i + Math.max(1, currentPage - 2);
                    if (pageNum > totalPages) return null;
                    return (
                      <button
                        key={pageNum}
                        onClick={() => setCurrentPage(pageNum)}
                        className={`px-3 py-1.5 text-xs sm:text-sm font-medium rounded-lg transition-colors ${
                          currentPage === pageNum
                            ? "bg-purple-600 text-white"
                            : "text-gray-600 dark:text-gray-400 hover:bg-gray-100 dark:hover:bg-gray-700 hover:text-gray-900 dark:hover:text-white"
                        }`}
                      >
                        {pageNum}
                      </button>
                    );
                  })}

                  <button
                    onClick={() => setCurrentPage((p) => Math.min(totalPages, p + 1))}
                    disabled={currentPage === totalPages}
                    className="p-2 rounded-lg border border-gray-200 dark:border-gray-700 text-gray-600 dark:text-gray-400 hover:text-gray-900 dark:hover:text-white disabled:opacity-40 disabled:cursor-not-allowed transition-colors"
                  >
                    <ChevronRightIcon className="w-4 h-4" />
                  </button>
                </div>
              </div>
            )}
          </>
        )}
      </div>

      {/* Create Group Modal */}
      {showCreateModal && (
        <div className="fixed inset-0 bg-black/50 backdrop-blur-sm flex items-center justify-center z-50 p-4">
          <div className="bg-white dark:bg-gray-800 rounded-2xl max-w-md w-full shadow-2xl border border-gray-200 dark:border-gray-700">
            <div className="border-b border-gray-200 dark:border-gray-700 px-6 py-4 flex items-center justify-between">
              <h3 className="text-lg font-bold text-gray-900 dark:text-white">Create New Group</h3>
              <button
                onClick={() => {
                  setShowCreateModal(false);
                  resetForm();
                }}
                className="p-1.5 text-gray-400 hover:text-gray-600 dark:hover:text-gray-300 rounded-lg transition-colors cursor-pointer"
              >
                <XMarkIcon className="w-5 h-5" />
              </button>
            </div>
            <form onSubmit={handleCreateGroup} className="p-6">
              <div className="space-y-4">
                <div>
                  <label className="block text-xs font-semibold text-gray-700 dark:text-gray-300 mb-1.5">
                    Group Name *
                  </label>
                  <input
                    type="text"
                    value={formData.groupName}
                    onChange={(e) => setFormData({ ...formData, groupName: e.target.value })}
                    className="w-full px-3.5 py-2.5 border border-gray-300 dark:border-gray-600 rounded-xl bg-white dark:bg-gray-700 text-gray-900 dark:text-white text-xs sm:text-sm focus:ring-2 focus:ring-purple-500 focus:border-transparent transition-all"
                    required
                    placeholder="e.g. VIP Customers"
                  />
                </div>
                <div>
                  <label className="block text-xs font-semibold text-gray-700 dark:text-gray-300 mb-1.5">
                    Description
                  </label>
                  <textarea
                    value={formData.otherMessage}
                    onChange={(e) => setFormData({ ...formData, otherMessage: e.target.value })}
                    className="w-full px-3.5 py-2.5 border border-gray-300 dark:border-gray-600 rounded-xl bg-white dark:bg-gray-700 text-gray-900 dark:text-white text-xs sm:text-sm focus:ring-2 focus:ring-purple-500 focus:border-transparent transition-all"
                    rows="3"
                    placeholder="Enter group description or notes"
                  />
                </div>
              </div>
              <div className="flex justify-end gap-3 mt-6 pt-4 border-t border-gray-100 dark:border-gray-700">
                <button
                  type="button"
                  onClick={() => {
                    setShowCreateModal(false);
                    resetForm();
                  }}
                  className="px-5 py-2 text-xs font-semibold text-gray-600 dark:text-gray-400 hover:bg-gray-100 dark:hover:bg-gray-700 rounded-xl transition-all cursor-pointer"
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  disabled={isSubmitting}
                  className="bg-purple-700 hover:bg-purple-800 disabled:bg-gray-400 text-white px-6 py-2 rounded-xl transition-all flex items-center gap-2 text-xs font-semibold shadow-sm shadow-purple-600/20 cursor-pointer"
                >
                  {isSubmitting ? (
                    <>
                      <div className="animate-spin rounded-full h-3.5 w-3.5 border-b-2 border-white"></div>
                      Creating...
                    </>
                  ) : (
                    <>
                      <CheckIcon className="w-4 h-4" />
                      Create Group
                    </>
                  )}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      {/* Edit Group Modal */}
      {showEditModal && selectedGroup && (
        <div className="fixed inset-0 bg-black/50 backdrop-blur-sm flex items-center justify-center z-50 p-4">
          <div className="bg-white dark:bg-gray-800 rounded-2xl max-w-md w-full shadow-2xl border border-gray-200 dark:border-gray-700">
            <div className="border-b border-gray-200 dark:border-gray-700 px-6 py-4 flex items-center justify-between">
              <h3 className="text-lg font-bold text-gray-900 dark:text-white">Edit Group</h3>
              <button
                onClick={() => {
                  setShowEditModal(false);
                  resetForm();
                }}
                className="p-1.5 text-gray-400 hover:text-gray-600 dark:hover:text-gray-300 rounded-lg transition-colors cursor-pointer"
              >
                <XMarkIcon className="w-5 h-5" />
              </button>
            </div>
            <form onSubmit={handleUpdateGroup} className="p-6">
              <div className="space-y-4">
                <div>
                  <label className="block text-xs font-semibold text-gray-700 dark:text-gray-300 mb-1.5">
                    Group Name *
                  </label>
                  <input
                    type="text"
                    value={formData.groupName}
                    onChange={(e) => setFormData({ ...formData, groupName: e.target.value })}
                    className="w-full px-3.5 py-2.5 border border-gray-300 dark:border-gray-600 rounded-xl bg-white dark:bg-gray-700 text-gray-900 dark:text-white text-xs sm:text-sm focus:ring-2 focus:ring-purple-500 focus:border-transparent transition-all"
                    required
                    placeholder="Enter group name"
                  />
                </div>
                <div>
                  <label className="block text-xs font-semibold text-gray-700 dark:text-gray-300 mb-1.5">
                    Description
                  </label>
                  <textarea
                    value={formData.otherMessage}
                    onChange={(e) => setFormData({ ...formData, otherMessage: e.target.value })}
                    className="w-full px-3.5 py-2.5 border border-gray-300 dark:border-gray-600 rounded-xl bg-white dark:bg-gray-700 text-gray-900 dark:text-white text-xs sm:text-sm focus:ring-2 focus:ring-purple-500 focus:border-transparent transition-all"
                    rows="3"
                    placeholder="Enter group description"
                  />
                </div>
              </div>
              <div className="flex justify-end gap-3 mt-6 pt-4 border-t border-gray-100 dark:border-gray-700">
                <button
                  type="button"
                  onClick={() => {
                    setShowEditModal(false);
                    resetForm();
                  }}
                  className="px-5 py-2 text-xs font-semibold text-gray-600 dark:text-gray-400 hover:bg-gray-100 dark:hover:bg-gray-700 rounded-xl transition-all cursor-pointer"
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  disabled={isSubmitting}
                  className="bg-purple-700 hover:bg-purple-800 disabled:bg-gray-400 text-white px-6 py-2 rounded-xl transition-all flex items-center gap-2 text-xs font-semibold shadow-sm shadow-purple-600/20 cursor-pointer"
                >
                  {isSubmitting ? (
                    <>
                      <div className="animate-spin rounded-full h-3.5 w-3.5 border-b-2 border-white"></div>
                      Updating...
                    </>
                  ) : (
                    <>
                      <CheckIcon className="w-4 h-4" />
                      Update Group
                    </>
                  )}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      {/* View Group Modal */}
      {showViewModal && selectedGroup && (
        <div className="fixed inset-0 bg-black/50 backdrop-blur-sm flex items-center justify-center z-50 p-4">
          <div className="bg-white dark:bg-gray-800 rounded-2xl max-w-4xl w-full max-h-[90vh] overflow-y-auto shadow-2xl border border-gray-200 dark:border-gray-700">
            <div className="sticky top-0 bg-white dark:bg-gray-800 border-b border-gray-200 dark:border-gray-700 px-6 py-4 flex items-center justify-between z-10">
              <h3 className="text-lg font-bold text-gray-900 dark:text-white">
                Group Details: {selectedGroup.groupName || selectedGroup.str_group_name}
              </h3>
              <button
                onClick={() => setShowViewModal(false)}
                className="p-1.5 text-gray-400 hover:text-gray-600 dark:hover:text-gray-300 rounded-lg transition-colors cursor-pointer"
              >
                <XMarkIcon className="w-5 h-5" />
              </button>
            </div>
            <div className="p-6">
              <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
                {/* Group Information */}
                <div>
                  <h4 className="font-semibold text-gray-900 dark:text-white mb-4 text-sm uppercase tracking-wider text-purple-600 dark:text-purple-400">
                    Group Information
                  </h4>
                  <div className="space-y-3 text-xs sm:text-sm bg-gray-50 dark:bg-gray-700/40 p-4 rounded-xl border border-gray-100 dark:border-gray-700">
                    <div className="flex justify-between py-1 border-b border-gray-200/50 dark:border-gray-600/50">
                      <span className="font-medium text-gray-500 dark:text-gray-400">Name:</span>
                      <span className="font-semibold text-gray-900 dark:text-white">
                        {selectedGroup.groupName || selectedGroup.str_group_name}
                      </span>
                    </div>
                    <div className="flex justify-between py-1 border-b border-gray-200/50 dark:border-gray-600/50">
                      <span className="font-medium text-gray-500 dark:text-gray-400">Description:</span>
                      <span className="text-gray-900 dark:text-white text-right max-w-[200px] truncate">
                        {selectedGroup.otherMessage || selectedGroup.str_description || "No description"}
                      </span>
                    </div>
                    <div className="flex justify-between py-1 border-b border-gray-200/50 dark:border-gray-600/50">
                      <span className="font-medium text-gray-500 dark:text-gray-400">Created by:</span>
                      <span className="text-gray-900 dark:text-white">
                        {selectedGroup.createdBy?.email || selectedGroup.str_created_by || "Admin"}
                      </span>
                    </div>
                    <div className="flex justify-between py-1 border-b border-gray-200/50 dark:border-gray-600/50">
                      <span className="font-medium text-gray-500 dark:text-gray-400">Created:</span>
                      <span className="text-gray-900 dark:text-white">
                        {selectedGroup.createdAt || selectedGroup.dttm_created_on
                          ? new Date(selectedGroup.createdAt || selectedGroup.dttm_created_on).toLocaleDateString()
                          : "-"}
                      </span>
                    </div>
                    <div className="flex justify-between py-1">
                      <span className="font-medium text-gray-500 dark:text-gray-400">Total Contacts:</span>
                      <span className="font-bold text-purple-600 dark:text-purple-400">
                        {groupContacts.length}
                      </span>
                    </div>
                  </div>
                </div>

                {/* Group Contacts */}
                <div>
                  <h4 className="font-semibold text-gray-900 dark:text-white mb-4 text-sm uppercase tracking-wider text-green-600 dark:text-green-400">
                    Group Contacts ({groupContacts.length})
                  </h4>
                  {loadingContacts ? (
                    <div className="py-10 text-center">
                      <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-green-600 mx-auto mb-2"></div>
                      <p className="text-xs text-gray-500">Loading contacts...</p>
                    </div>
                  ) : groupContacts.length > 0 ? (
                    <div className="space-y-2 max-h-72 overflow-y-auto pr-1">
                      {groupContacts.map((contact, index) => (
                        <div
                          key={contact._id || index}
                          className="flex items-center justify-between p-3 bg-gray-50 dark:bg-gray-700/60 rounded-xl border border-gray-100 dark:border-gray-600/50"
                        >
                          <div>
                            <div className="text-xs sm:text-sm font-semibold text-gray-900 dark:text-white">
                              {contact.name || contact.str_name || "No Name"}
                            </div>
                            <div className="text-xs font-mono text-gray-500 dark:text-gray-400">
                              {contact.number || contact.str_phone_number}
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                  ) : (
                    <div className="py-8 text-center bg-gray-50 dark:bg-gray-700/30 rounded-xl border border-dashed border-gray-200 dark:border-gray-700">
                      <p className="text-xs sm:text-sm text-gray-500 dark:text-gray-400">
                        No contacts in this group yet.
                      </p>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
